export const appVersion = '1.2.3-rc.3';
